import React from "react";
import { Icon, Popover } from "@clarkinc/zest-design-system";
import SocialShareDropdown from "./SocialShareDropdown";
import spritePath from "~/common/Icons/Standard/standard-sprite.svg";
const worksWithPopoverId = "works-with-popover-id";
interface SocialShareSectionProps {
  url: string;
  media: string;
  description: string;
  hasGallery?: boolean;
  titleSection?: boolean;
  youMayAlsoNeedUrl?: string;
  displayAskButton?: boolean;
}
const SocialShareSection = ({
  url,
  media,
  description,
  hasGallery = true,
  titleSection,
  youMayAlsoNeedUrl,
  displayAskButton = true
}: Readonly<SocialShareSectionProps>) => {
  const handleAskButtonClick = (event: React.SyntheticEvent) => {
    event.preventDefault();
    const elementToJumpTo = document?.getElementById("customerQA");
    elementToJumpTo?.focus();
    elementToJumpTo?.scrollIntoView();
  };
  const buttonProps = {
    onClick: handleAskButtonClick
  };
  return <div className={`bg-white border-gray-200 border-solid border hidden p-3 lt:block ${hasGallery && "border-t-0 lt:pt-0 "} ${titleSection ? "border-b-0" : "rounded-b border-b mb-3"}`} data-sentry-component="SocialShareSection" data-sentry-source-file="SocialShareSection.tsx">
      <div className={`flex items-center "
          ${titleSection ? "justify-between" : "justify-end"}`}>
        {titleSection ? <>
            <h2 className="flex items-center mb-0 text-lg leading-5">
              Works With
              <Popover>
                <Popover.Trigger contentId={worksWithPopoverId} className="flex ml-1">
                  <Icon name="ri-question-fill" aria-label="more information" size="xsmall" className="fill-green-500" />
                </Popover.Trigger>
                <Popover.Content id={worksWithPopoverId} placement="right">
                  &quot;Works With&quot; items are guaranteed to work with the
                  item you are viewing, such as lids that will fit a cup or
                  casters that will fit a piece of equipment. If an item is not
                  listed in this section, we do not guarantee that it will work
                  with the product you are viewing and do not recommend that you
                  purchase them for use together.
                </Popover.Content>
              </Popover>
              {youMayAlsoNeedUrl && <a className="font-semibold text-xs ml-2" href={youMayAlsoNeedUrl}>
                  View All Items
                </a>}
            </h2>
          </> : null}
        <div className="hidden lt:block">
          <SocialShareDropdown url={url} media={media} description={description} data-sentry-element="SocialShareDropdown" data-sentry-source-file="SocialShareSection.tsx" />
          {displayAskButton ? <button className="btn btn-small text-sm h-[26px] inline-flex items-center justify-center text-white font-semibold chat-ask-button-gradient chat-ask-button-hover" data-testid="askButton" type="button" {...buttonProps}>
              <Icon className="w-5 h-[18px] pr-1" name="askButton-question" spriteSheetHref={spritePath} />
              {" Ask a Question"}
            </button> : null}
        </div>
      </div>
    </div>;
};
export default SocialShareSection;